
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppHelper } from '../../shared/appHelper/appHelper';
import { Branch } from '../../Models/branch';
import { User } from '../../Models/user';
import { BranchUser } from '../../Models/branch-user';
import { TServicePagingResult } from '../../shared/Infra/TServicePagingResult';
import { TServiceResult } from '../../shared/Infra/TServiceResult';
import { ServiceResult } from '../../shared/Infra/ServiceResult';
import { TermFilter } from '../../../app/shared/Infra/term-filter';
import { BranchDocumentType } from '../../Models/branch-document-type';
import { BranchDocument } from '../../Models/branch-document';
import { BranchRequest } from '../../Models/branch-request';
import { ServiceBase } from '../service-base/service-base';
import { LocalRepository } from '../data/repository/local-repository';
import { BranchGallery } from "../../Models/branchGallery";



@Injectable({
  providedIn: 'root'
})
export class BranchService extends ServiceBase<Branch> {
  branchUrl = `${AppHelper.SSoApi}Branch`;

  constructor(http: HttpClient, repo: LocalRepository) {
    super("Branch", http, repo)
  }
  public editParent(branchId: number, parentId: number): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(this.branchUrl + '/EditParent?branchId=' + branchId + '&parentId=' + parentId, parentId)
  }

  public addBranch(branch: Branch): Observable<TServiceResult<number>> {
    return this.http.post<TServiceResult<number>>(this.branchUrl + '/AddBranch', branch)
  }

  public editBranch(branch: Branch): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(this.branchUrl + '/EditBranch', branch)
  }

  public deleteBranch(branchId: number): Observable<TServiceResult<number>> {
    return this.http.get<TServiceResult<number>>(this.branchUrl + '/DeleteBranch?branchId=' + branchId)
  }

  getBranches(): Observable<TServiceResult<Branch[]>> {
    return this.http.get<TServiceResult<Branch[]>>(this.branchUrl + '/GetBranches')
  }

  getSubBranches(id: number): Observable<TServiceResult<Branch[]>> {
    return this.http.get<TServiceResult<Branch[]>>(this.branchUrl + `/getSubBranches?id=${id}`)
  }
  getSubBranchesByFilter(filter: TermFilter): Observable<TServiceResult<Branch[]>> {
    return this.http.post<TServiceResult<Branch[]>>(this.branchUrl + `/filterSubBranches`, filter)
  }

  public getBranchById(branchId: number): Observable<TServiceResult<Branch>> {
    return this.http.get<TServiceResult<Branch>>(`${this.ApiUrl}/GetBranchById?branchId=` + branchId)
  }

  public getUsersInBranch(branchId: number): Observable<TServiceResult<BranchUser[]>> {
    return this.http.get<TServiceResult<BranchUser[]>>(this.branchUrl + '/GetUsersInBranch?branchId=' + branchId)
  }

  public getUsersNotInBranch(branchId: number): Observable<TServiceResult<User[]>> {
    return this.http.get<TServiceResult<User[]>>(this.branchUrl + '/GetUsersNotInBranch?branchId=' + branchId)
  }

  public getUsersByFilterInBranch(filter: string, branchId: number): Observable<TServiceResult<BranchUser[]>> {
    return this.http.get<TServiceResult<BranchUser[]>>(this.branchUrl + '/GetUsersByFilterInBranch?filter=' + filter + '&&branchId=' + branchId)
  }

  public getUsersByFilterNotInBranch(filter: string, branchId: number): Observable<TServiceResult<User[]>> {
    return this.http.get<TServiceResult<User[]>>(this.branchUrl + '/GetUsersByFilterNotInBranch?filter=' + filter + '&&branchId=' + branchId)
  }

  public addBranchMember(userId: string, branchId: number): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(this.branchUrl + '/AddBranchMember', { 'UserId': userId, 'BranchId': branchId })
  }

  public removeBranchMember(userId: string, branchId: number): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(this.branchUrl + '/RemoveBranchMember', { 'UserId': userId, 'BranchId': branchId })
  }
  public getAssignedBranches(userId?: string): Observable<TServiceResult<Branch[]>> {
    let action = '/GetAssignedBranches';
    if (userId != null) {
      action += '?userId=' + userId;
    }
    return this.http.get<TServiceResult<Branch[]>>(this.ApiUrl + action);
  }
  public setDefaultBranch(branchId: number): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(this.branchUrl + '/SetDefaultBranch?branchId=' + branchId, { 'branchId': branchId })
  }

  public getBranchDocumentType(): Observable<TServiceResult<BranchDocumentType[]>> {
    return this.http.get<TServiceResult<BranchDocumentType[]>>(this.branchUrl + '/GetBranchDocumentType')
  }
  public getBranchDocument(id): Observable<TServiceResult<BranchDocument[]>> {
    return this.http.get<TServiceResult<BranchDocument[]>>(this.branchUrl + '/GetBranchDocumentsById?branchId=' + id)
  }
  public addDocument(branchDocument: BranchDocument): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(this.branchUrl + '/AddDocument', branchDocument)
  }
  public removeBranchDocumentById(id): Observable<ServiceResult> {
    return this.http.get<ServiceResult>(this.branchUrl + '/RemoveBranchDocumentById?documentId=' + id)
  }
  public getBranchCapacity(id): Observable<TServiceResult<Branch>> {
    return this.http.get<TServiceResult<Branch>>(this.branchUrl + '/GetBranchCapacity?branchId=' + id)
  }
  public canEdeitBranch(id): Observable<TServiceResult<boolean>> {
    return this.http.get<TServiceResult<boolean>>(this.branchUrl + '/CanEdeitBranch?branchId=' + id)
  }

  addBranchRequest(branchRequest: BranchRequest): Observable<TServiceResult<string>> {
    return this.http.post<TServiceResult<string>>(this.branchUrl + '/AddBranchRequest', branchRequest)
  }
  editBranchRequest(branchRequest: BranchRequest): Observable<TServiceResult<string>> {
    return this.http.post<TServiceResult<string>>(this.branchUrl + '/EditBranchRequest', branchRequest)
  }

  getBranchRequestByCode(referralCode: string): Observable<TServiceResult<BranchRequest>> {
    let filter = new TermFilter();
    filter.searchTerm = referralCode;
    return this.http.post<TServiceResult<BranchRequest>>(this.branchUrl + '/GetBranchRequestByCode', filter)
  }

  editBranchRequestImage(referralCode, file): Observable<TServiceResult<BranchRequest>> {
    return this.http.post<TServiceResult<BranchRequest>>(this.branchUrl + '/EditBranchRequestImage?branchRequestCode=' + referralCode, file)
  }

  getWaitingBranchRequests(term: TermFilter): Observable<TServicePagingResult<BranchRequest[]>> {
    return this.http.post<TServicePagingResult<BranchRequest[]>>(this.branchUrl + '/GetWaitingBranchRequests', term)
  }

  setBranchRequestStatus(branchRequestId, status, maxUserCount, maxSubBranch): Observable<TServiceResult<number>> {
    return this.http.get<TServiceResult<number>>(this.branchUrl + '/SetBranchRequestStatus?branchRequestCode=' + branchRequestId + '&status=' + status + '&maxUserCount=' + maxUserCount + '&maxSubBranch=' + maxSubBranch)
  }

  setBranchRequestStatus2(branchRequestId, status, maxUserCount, maxSubBranch): Observable<TServiceResult<number>> {
    return this.http.post<TServiceResult<number>>(this.branchUrl + '/SetBranchRequestStatus',
    {
      branchRequestCode:branchRequestId, 
      status:status,
      maxUserCount:maxUserCount,
      maxSubBranch:maxSubBranch
    })
  }

  public getWaitingBranchRequestCount(): Observable<TServiceResult<number>> {
    return this.http.get<TServiceResult<number>>(this.branchUrl + '/GetWaitingBranchRequestCount')
  }
  public checkBranchRequeCode(referralCode): Observable<TServiceResult<boolean>> {
    return this.http.get<TServiceResult<boolean>>(this.branchUrl + '/CheckBranchRequeCode?branchRequestCode=' + referralCode)

  }

  public setBranchStatus(branchId: number, status: boolean): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(this.branchUrl + `/SetBranchStatus?branchId=${branchId}&IsActivate=${status}`, null)
  }
  public createGallery(branchId: number, image: BranchGallery): Observable<TServiceResult<BranchGallery>> {
    return this.http.post<TServiceResult<BranchGallery>>(`${this.ApiUrl}/CreateBranchGallery/${branchId}`, image)
  }
  public uploadLogo(image: BranchGallery): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(`${this.ApiUrl}/UploadLogo`, image)
  }
  public RemoveImage(branchGalleryId: number): Observable<ServiceResult> {
    return this.http.delete<ServiceResult>(`${this.ApiUrl}/BranchGallery/${branchGalleryId}`)
  }


  public getImages(branchId: number): Observable<TServiceResult<string[]>> {
    return this.http.get<TServiceResult<string[]>>(`${this.ApiUrl}/BranchGallery/${branchId}`);
  }
  public getImagesAdmin(branchId: number): Observable<TServiceResult<BranchGallery[]>> {
    return this.http.post<TServiceResult<BranchGallery[]>>(`${this.ApiUrl}/BranchGallery/${branchId}`, null);
  }

  public getBranchSuggestion(branchName: string): Observable<TServiceResult<Branch[]>> {
    return this.http.post<TServiceResult<Branch[]>>(`${this.ApiUrl}/GetBranchSuggestion?branchName=${branchName}`, null);
  }
}
